import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Button } from "react-admin";
import { useFormContext } from "react-hook-form";
import InputCurrencyField from "../components/inputComponents/InputCurrencyField";
import InputField2 from "../../common/InputComponents/InputField2";
import InputDateField from "../../common/InputComponents/InputDateFieldOld";
import InputSelectField from "../../common/InputComponents/InputSelectField";
import {
  useDataProvider,
  useGetOne,
  useNotify,
  useGetIdentity,
} from "react-admin";
import { useMutation, useQueryClient } from "react-query";
import NewMetaDataRules from "../components/NewMetaDataRules";
import ButtonGroup from "@mui/material/ButtonGroup";
import moment from "moment";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteFileConfirmBtn from "../../common/DeleteFileConfirmBtn";
import SummaryTable from "./SummaryTable";
import DeleteUnsaveRecords from "../../common/DeleteUnsaveRecords";
import CustomPreviewUpload from "../../common/CustomPreviewUpload";
import { JSONTree } from "react-json-tree";
import { NumericFormat } from "react-number-format";
import CalculateMonthlyGrossPay from "../../../utils/CalculateMonthlyGrossPay";
import CalculateAnnualGrossPay from "../../../utils/CalculateAnnualGrossPay";
import AvgPay from "../../../utils/AvgPay";
import { calculatePayFrequency } from "../../../utils/caluculateFrequency/calculatePayFrequency";
import {
  inferPayPeriodEndDate,
  inferPayPeriodStartDate,
} from "../../../utils/caluculateFrequency/payPeriodDateInference";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { STATUS_COLORS } from "../components/utils/MetadataUtils";
import Link from "@mui/material/Link";

const METADATA_TRACKER_BASE_URL = "https://docuverus3.sharepoint.com/sites/SupportTeam/Lists/Advanced%20Metadata%20Tracker/AllItems.aspx?view=7&q=";
const METADATA_TRACKER_WINDOW_NAME = "metadata-tracker";
const METADATA_LEGEND_INDENT_PX = 287;

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            paddingLeft: 3,
            paddingRight: 3,
            paddingBottom: 3,
            paddingTop: 1,
          }}
        >
          <Box component="div">{children}</Box>
        </Box>
      )}
    </div>
  );
}
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
const pay_frequency = [
  { value: "Weekly", label: "Weekly" },
  { value: "Bi-Weekly", label: "Bi-Weekly" },
  { value: "Monthly", label: "Monthly" },
  { value: "Bi-Monthly", label: "Bi-Monthly" },
  { value: "Quarterly", label: "Quarterly" },
  { value: "Yearly", label: "Yearly" },
  { value: "One-Time", label: "One-Time" },
  { value: "Custom Period", label: "Custom Period" },
];
const socr_flags = [
  { label: "Gross pay", value: "Gross pay" },
  { label: "Net pay", value: "Net pay" },
  { label: "Pay period start date", value: "Pay period start date" },
  { label: "Pay period end date", value: "Pay period end date" },
  { label: "Pay date", value: "Pay date" },
  { label: "Pay frequency", value: "Pay frequency" },
];

export default function EmpFileField({
  removeManualRecord,
  empSource,
  setError,
  field,
  index,
  value,
  // handleOnChange,
  sourceEmpIndex,
  role,
  mlClassDetails,
  trn_id,
}) {
  const dataProvider = useDataProvider();
  const {
    control,
    watch,
    getValues,
    clearErrors,
    setValue: setFormValue,
    formState,
    trigger,
  } = useFormContext();
  const { identity, isLoading: identityLoading } = useGetIdentity();
  const { data: meta_d_response } = useGetOne('getMetaData', { id: 3, meta: { trn_id } }, { refetchOnWindowFocus: false, staleTime: 5 })
  const notify = useNotify();
  const queryClient = useQueryClient();
  const [mlFlag, setMlFlag] = React.useState(false);
  const {
    mutate: paystubProcessing,
    isLoading: deletePaystubProcessing,
    isSuccess: paystubProcessingSuccess,
  } = useMutation(
    "paystubProcessing",
    (data: any) => dataProvider.paystubProcessing({ ...data }),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries(["income"]);
        notify("Paystub processing done successfully...", {
          type: "success",
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      },
      onError: (data) => {
        alert("Fail processing paystub");
      },
      onMutate: () => {
        notify("Paystub is processing...", {
          type: "info",
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      },
    }
  );
  const handleFlagPaystub = async (index) => {
    const values = watch(`employer.${sourceEmpIndex}.files.${index}`);

    if (values.paystub_type) {
      //
      paystubProcessing({
        subUrl: "/ml/flagPaystub",
        IncomeRowID: values.income_row_id,
        ApplicationEmployerID: empSource.id,
        applicationDocumentID: values?.application_document_id,
        application_id: empSource?.application_id,
        filename: values.file_name,
        file_path: values.path,
        old_type: values.doc_state_type ? values.doc_state_type : "",
        new_type: values.paystub_type ? values.paystub_type.value : "",
        socr_error_fields: [],
        application: "docupload",
        request_from: "Admin",
        request_from_id: identity?.super_user_id,
        DocumentTypeID: 3,
        source_id: sourceEmpIndex + 1,
        trn_id: trn_id,
        method: "POST",
      });
    } else {
      setError(
        `employer.${sourceEmpIndex}.files.${index}.paystub_type`,
        { type: "required", message: "required" },
        { shouldFocus: true }
      );
    }
  };

  const handleFlagSocrField = async (index) => {
    const values = watch(`employer.${sourceEmpIndex}.files.${index}`);
    if (values.socr_error_fields && values.socr_error_fields?.length > 0) {
      //
      paystubProcessing({
        subUrl: "/ml/flagPaystub",
        IncomeRowID: values.income_row_id,
        ApplicationEmployerID: empSource.id,
        applicationDocumentID: values?.application_document_id,
        application_id: empSource?.application_id,
        filename: values.file_name,
        file_path: values.path,
        old_type: values.doc_state_type ? values.doc_state_type : "",
        new_type: "0",
        application: "docupload",
        request_from: "Admin",
        socr_error_fields: values.socr_error_fields.map(
          (socr_flag) => socr_flag.value
        ),
        request_from_id: identity?.super_user_id,
        DocumentTypeID: 3,
        source_id: sourceEmpIndex + 1,
        trn_id: trn_id,
        method: "POST",
      });
    } else {
      setError(
        `employer.${sourceEmpIndex}.files.${index}.socr_error_fields`,
        { type: "required", message: "required" },
        { shouldFocus: true }
      );
    }
  };

  const handleReprocessingPaystub = async (index) => {
    const values = getValues(`employer.${sourceEmpIndex}.files.${index}`);
    if (values.paystub_type) {
      const data = {
        subUrl: "/income/paystubReprocess",
        IncomeRowID: values.income_row_id,
        ApplicationEmployerID: empSource.id,
        applicationDocumentID: values?.application_document_id,
        application_id: empSource?.application_id,
        filename: values.file_name,
        file_path: values.path,
        old_type: values.doc_state_type ? values.doc_state_type : "",
        new_type: values.paystub_type ? values.paystub_type.value : "",
        socr_error_fields: [],
        application: "docupload",
        request_from: "Admin",
        request_from_id: identity?.super_user_id,
        DocumentTypeID: 3,
        source_id: sourceEmpIndex + 1,
        trn_id: trn_id,
        method: "POST",
      };
      paystubProcessing(data);
    } else {
      setError(
        `employer.${sourceEmpIndex}.files.${index}.paystub_type`,
        { type: "required", message: "required" },
        { shouldFocus: true }
      );
    }
  };

  const renderLegend = () => (
    <div className="d-flex align-items-center flex-wrap" style={{ fontSize: '10px', gap: '12px', paddingLeft: `${METADATA_LEGEND_INDENT_PX}px` }}>
      <span className="d-flex align-items-center">
        <CheckCircleOutlineIcon fontSize="small" sx={{ color: STATUS_COLORS.PASS, marginRight: '4px' }} />
        Passes validation rules
      </span>
      <span className="d-flex align-items-center">
        <ReportProblemOutlinedIcon fontSize="small" sx={{ color: STATUS_COLORS.FAIL, marginRight: '4px' }} />
        Fails validation rules
      </span>
      <span className="d-flex align-items-center">
        <RadioButtonUncheckedIcon fontSize="small" sx={{ color: STATUS_COLORS.NA, marginRight: '4px' }} />
        No validation rules
      </span>
      <span className="d-flex align-items-center">
        <AddCircleOutlineIcon fontSize="small" sx={{ color: '#9e9e9e', marginRight: '4px' }} />
        Optional font is in the document
      </span>
      <span className="d-flex align-items-center">
        <RemoveCircleOutlineIcon fontSize="small" sx={{ color: '#9e9e9e', marginRight: '4px' }} />
        Optional font is not in the document
      </span>
    </div>
  );
  const [expanded, setExpanded] = React.useState<string | false>("panel1");

  const handleChangeCollapse =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  const grossPayWatch = watch(
    `employer.${sourceEmpIndex}.files.${index}.Gross_Pay`
  );
  const payFrequencyWatch = watch(
    `employer.${sourceEmpIndex}.files.${index}.Pay_frequency`
  );


  const startDateWatch = watch(
    `employer.${sourceEmpIndex}.files.${index}.Start_date`
  );

  const endDateWatch = watch(
    `employer.${sourceEmpIndex}.files.${index}.End_date`
  );


  const [previousPayFrequency, setPreviousPayFrequency] = React.useState<{ label: string; value: string; } | null>(null);

  React.useEffect(() => {
    const payEndDateSource = `employer.${sourceEmpIndex}.files.${index}.End_date`;

    if (!startDateWatch || !endDateWatch) {
      clearErrors(payEndDateSource);
      return;
    }

    const startDate = moment(startDateWatch);
    const endDate = moment(endDateWatch);

    if (startDate.isValid() && endDate.isValid() && startDate.isAfter(endDate)) {
      setError(
        payEndDateSource,
        { type: "validate", message: "Invalid date range" },
        { shouldFocus: false }
      );
      return;
    }

    clearErrors(payEndDateSource);
  }, [clearErrors, endDateWatch, index, setError, sourceEmpIndex, startDateWatch]);


  React.useEffect(() => {

    if (!!payFrequencyWatch?.value && !!endDateWatch && !!startDateWatch) {
      const newPayFrequency = calculatePayFrequency({
        startDate: getValues(`employer.${sourceEmpIndex}.files.${index}.Start_date`),
        endDate: getValues(`employer.${sourceEmpIndex}.files.${index}.End_date`)
      });

      if (newPayFrequency !== null && newPayFrequency !== previousPayFrequency) {
        setFormValue(
          `employer.${sourceEmpIndex}.files.${index}.Pay_frequency`,
          newPayFrequency
        );
        setPreviousPayFrequency(newPayFrequency);
      }
    }
  }, [startDateWatch, endDateWatch, payFrequencyWatch]);

  const formatDate = (date) => {
    if (!date)
      return date;
    const d = new Date(date);
    const month = d.getMonth() + 1; // Months are zero based, so we add 1
    const day = d.getDate();
    const year = d.getFullYear();

    const formattedMonth = month < 10 ? `0${month}` : `${month}`;
    const formattedDay = day < 10 ? `0${day}` : `${day}`;
    return `${formattedMonth}/${formattedDay}/${year}`;
  };
  React.useEffect(() => {

    if (!!payFrequencyWatch?.value && endDateWatch && !startDateWatch) {
      const newstartDate = inferPayPeriodStartDate(payFrequencyWatch, endDateWatch);
      const fdate = formatDate(newstartDate);

      if (!fdate) return;

      setFormValue(
        `employer.${sourceEmpIndex}.files.${index}.Start_date`, fdate);
    }
  }, [payFrequencyWatch?.value, endDateWatch, startDateWatch]);

  React.useEffect(() => {
    if (!!payFrequencyWatch?.value && startDateWatch && !endDateWatch) {
      const newstartDate = inferPayPeriodEndDate(payFrequencyWatch, startDateWatch);
      const fdate = formatDate(newstartDate);
      if (!fdate) return;
      setFormValue(`employer.${sourceEmpIndex}.files.${index}.End_date`,
        fdate
      );
    }
  }, [payFrequencyWatch?.value, startDateWatch, endDateWatch]);

  React.useEffect(() => {
    if (!payFrequencyWatch?.value && startDateWatch && endDateWatch) {
      const newPayFrequency = calculatePayFrequency({
        startDate: getValues(`employer.${sourceEmpIndex}.files.${index}.Start_date`),
        endDate: getValues(`employer.${sourceEmpIndex}.files.${index}.End_date`)
      });
      setFormValue(
        `employer.${sourceEmpIndex}.files.${index}.Pay_frequency`,
        newPayFrequency
      );
    }
  }, [payFrequencyWatch?.value, startDateWatch, endDateWatch]);
  const [originalPayFrequency, setOriginalPayFrequency] = useState(null);



  React.useEffect(() => {
    if (startDateWatch && endDateWatch) {
      setOriginalPayFrequency(payFrequencyWatch);
    }
  }, [startDateWatch, endDateWatch]);

  const handleOnChange = (selectedOption) => {
    if (startDateWatch && endDateWatch) {
      setFormValue(`employer.${sourceEmpIndex}.files.${index}.Pay_frequency`, originalPayFrequency);
    } else {
      setFormValue(`employer.${sourceEmpIndex}.files.${index}.Pay_frequency`, selectedOption);
    }
  };

  return (
    <>
      <TabPanel key={field.empId || field.fieldId || index} value={value} index={index}>
        <div className="d-flex justify-content-between">
          <h6>{`${field.file_name || "New paystub"}`}</h6>
          {!field.not_save && (
            <DeleteFileConfirmBtn
              isArrayRemove={!field.path}
              doc_id={
                field.application_document_id != 0
                  ? field.application_document_id
                  : field.income_row_id
              }
              tag={"delete_document_income"}
              invalidateQueries={"income"}
            />
          )}
          {field.not_save && (
            <DeleteUnsaveRecords
              removeFun={() => {
                removeManualRecord();
              }}
            />
          )}
        </div>
        <div className="row">
          <div className="col-12 col-md-6 col-lg-6">
            <div className="row">
              <div className="col-6 col-md-6 col-lg-6">
                <InputDateField
                  // onChangeCallback={() => {
                  //   handleOnChange();
                  // }}
                  label="Period Start Date"
                  source={`employer.${sourceEmpIndex}.files.${index}.Start_date`}
                  placeholder=""
                  stopAutoFocus={true}
                />
              </div>
              <div className="col-6 col-md-6 col-lg-6">
                <InputDateField
                  // onChangeCallback={() => {
                  //   handleOnChange();
                  // }}
                  label="Pay End Date"
                  source={`employer.${sourceEmpIndex}.files.${index}.End_date`}
                  placeholder=""
                  stopAutoFocus={true}
                />
              </div>
              <div className="col-6 col-md-6 col-lg-6">
                <InputDateField
                  // onChangeCallback={() => {
                  //   handleOnChange();
                  // }}
                  label="Pay Date"
                  source={`employer.${sourceEmpIndex}.files.${index}.Pay_date`}
                  placeholder=""
                  stopAutoFocus={true}
                />
              </div>
              <div className="col-6 col-md-6 col-lg-6">
                <InputSelectField
                  // disable={startDateWatch && endDateWatch}
                  onChangeCallback={handleOnChange}
                  isClearable={false}
                  label="Pay Frequency"
                  source={`employer.${sourceEmpIndex}.files.${index}.Pay_frequency`}
                  options={pay_frequency}
                  stopAutoFocus={true}
                />
              </div>
              <div className="col-6 col-md-6 col-lg-6">
                <InputCurrencyField
                  // onChangeCallback={() => {
                  //   handleOnChange();
                  // }}
                  label="Gross Pay"
                  source={`employer.${sourceEmpIndex}.files.${index}.Gross_Pay`}
                  placeholder=""
                  disabled={false}
                />
              </div>
              <div className="col-6 col-md-6 col-lg-6">
                <InputCurrencyField
                  // onChangeCallback={() => {
                  //   handleOnChange();
                  // }}
                  type="number"
                  label="Net Pay"
                  source={`employer.${sourceEmpIndex}.files.${index}.Net_Pay`}
                  placeholder=""
                  disabled={false}
                />
              </div>

              <div className="col-6 col-md-6 col-lg-6">
                <label
                  className={`form-label`}
                >
                  Monthly Income
                </label>
                <NumericFormat
                  value={AvgPay(CalculateMonthlyGrossPay(watch(`employer.${sourceEmpIndex}.files`)),watch(`employer.${sourceEmpIndex}.files`))}
                  disabled={true}
                  className={`form-control cus-input-control`}
                  prefix={'$'}
                  placeholder="$ 0.00"
                  fixedDecimalScale={true}
                  decimalScale={2}
                />
              </div>
              <div className="col-6 col-md-6 col-lg-6">
              <label
                  className={`form-label`}
                >
                  Yearly Income
                </label>
                <NumericFormat
                  value={CalculateAnnualGrossPay(watch(`employer.${sourceEmpIndex}.files`))}
                  disabled={true}
                  className={`form-control cus-input-control`}
                  prefix={'$'}
                  placeholder="$ 0.00"
                  fixedDecimalScale={true}
                  decimalScale={2}
                />
                <br />
              </div>

              {field.path && (
                <>
                  <div className="col-6 col-md-6 col-lg-6 d-flex">
                    <InputField2
                      type="text"
                      label="Paystub Type"
                      source={`employer.${sourceEmpIndex}.files.${index}.doc_state_type`}
                      placeholder=""
                      disable={true}
                    />{" "}
                  </div>

                </>
              )}
            </div>
            {role === "Docuverus Super Admin" &&
              field.application_document_id !== "0" &&
              mlFlag && (
                <div className="card p-2" style={{ background: "#FDFFF5" }}>
                  <div className="row">
                    <div className="col-4 col-md-4 col-lg-4">
                      <InputSelectField
                        label="Select Paystub"
                        source={`employer.${sourceEmpIndex}.files.${index}.paystub_type`}
                        options={mlClassDetails}
                      />
                    </div>

                    <div className="col-6 col-md-6 col-lg-6">
                      <InputSelectField
                        label="Flag SOCR"
                        source={`employer.${sourceEmpIndex}.files.${index}.socr_error_fields`}
                        options={socr_flags}
                        multiple={true}
                      />
                    </div>

                    <div className="col-3 col-md-3 col-lg-3">
                      <div className="card">
                        <ButtonGroup
                          style={{ color: "#fff" }}
                          size="large"
                          orientation="vertical"
                          variant="contained"
                          aria-label="outlined primary button group"
                        >
                          <Button
                            label={"Flag Paystub"}
                            disabled={field?.isFlagPaystub}
                            onClick={() => handleFlagPaystub(index)}
                            className={"btn btn-primary"}
                          ></Button>
                          <Button
                            label={"Flag SOCR Field"}
                            disabled={field?.isFlagSocrFields}
                            onClick={() => handleFlagSocrField(index)}
                          ></Button>
                          <Button
                            label={"Reprocess"}
                            disabled={field?.isReprocess}
                            onClick={() => handleReprocessingPaystub(index)}
                          ></Button>
                        </ButtonGroup>
                      </div>
                    </div>
                  </div>
                </div>
              )}
          </div>
          <div className="col-12 col-md-6 col-lg-6">
            <CustomPreviewUpload startpage={field.startpage} endpage={field.endpage} filePath={field?.path} docId={field?.application_document_id} />
          </div>
          <div className="col-12">
            <br />
            {field?.path && role === "Docuverus Super Admin" && (
              <div className="metadata-wrap">
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleChangeCollapse("panel1")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        gap: 2,
                        flexWrap: "wrap",
                      }}
                      >
                        <Typography sx={{ width: "33%", flexShrink: 0 }}>
                          Metadata Checks
                          {field?.doc_state_type && (
                            <>
                              {" - "}
                              <Link
                                href={`${METADATA_TRACKER_BASE_URL}${encodeURIComponent(field.doc_state_type)}`}
                                target={METADATA_TRACKER_WINDOW_NAME}
                                underline="hover"
                                onClick={(e) => e.stopPropagation()}
                                onMouseDown={(e) => e.stopPropagation()}
                                onFocus={(e) => e.stopPropagation()}
                              >
                                {field.doc_state_type}
                              </Link>
                            </>
                          )}
                        </Typography>
                      {expanded === "panel1" && <Box sx={{ width: "100%" }}>{renderLegend()}</Box>}
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    <NewMetaDataRules
                      docStateType={field?.doc_state_type}
                      metaDataCheck={
                        meta_d_response?.records?.rules.find(
                          (item) =>
                            item.ApplicationDocumentID ==
                            field?.application_document_id
                        )?.metaDataCheck || []
                      }
                      alignmentError={
                        meta_d_response?.records?.rules.find(
                          (item) =>
                            item.ApplicationDocumentID ==
                            field?.application_document_id
                        )?.alignmentError || []
                      }
                      unknownTemplate={
                        meta_d_response?.records?.rules.find(
                          (item) =>
                            item.ApplicationDocumentID ==
                            field?.application_document_id
                        )?.unknownTemplate || []
                      }
                      fraudTemplate={
                        meta_d_response?.records?.rules.find(
                          (item) =>
                            item.ApplicationDocumentID ==
                            field?.application_document_id
                        )?.fraudTemplate || []
                      }
                    />
                  </AccordionDetails>
                </Accordion>
              </div>
            )}
          </div>
        </div>
        {field?.path && role === "Docuverus Super Admin" && (
          <SummaryTable sourceEmpIndex={sourceEmpIndex} fileIndex={index} />
        )}
      </TabPanel>
    </>
  );
}
